import { useEffect, FC } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuthenticatedSelector } from 'app/store/Auth/selectors';
import { useAppDispatch, useAppSelector } from 'app/store';
import { SignUpForm } from 'app/components/SignUp';
import { routes } from 'app/routing/routesConfig';
import { ChakraAuthContentWrapper } from 'app/components/Core';
import queryString from 'query-string';
import { signUpStartedAction } from 'app/store/Mixpanel/slice';

export const SignUp: FC = () => {
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  const getSearchParams = () => {
    const searchParams = new URLSearchParams(search);
    if (searchParams.get('signUpStarted')) {
      return search;
    }
    const pid = searchParams.get('pid');
    const gclid = searchParams.get('gclid');
    const referral = searchParams.get('referral');

    let origin = 'Organic';

    if (pid) {
      origin = pid;
    }
    if (gclid) {
      origin = `Google ad. Click id: ${gclid}`;
    }
    if (referral) {
      origin = 'Referral';
    }

    dispatch(signUpStartedAction(origin));

    searchParams.append('signUpStarted', 'true');

    return searchParams.toString();
  };

  useEffect(() => {
    const searchParams = getSearchParams();
    if (
      !isAuthenticated &&
      (!pathname.includes(routes.signUpBasic.path) ||
        !pathname.includes(routes.signUpDetails.path) ||
        !pathname.includes(routes.signUpPersona.path))
    ) {
      navigate(
        { pathname: routes.signUpBasic.path, search: searchParams },
        { replace: true }
      );
    } else {
      navigate({ pathname, search: searchParams }, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ChakraAuthContentWrapper>
      <SignUpForm
        afterSubmit={(userName, clientId) => {
          const currentParams = queryString.parse(search);
          navigate({
            pathname: routes.confirmAccount.path,
            search: queryString.stringify({
              username: userName,
              clientId,
              ...currentParams,
            }),
          });
        }}
      />
    </ChakraAuthContentWrapper>
  );
};
